module.exports = __webpack_public_path__ + "assets/img/people.e62c0311.png";